import {
  NEW_GUARANTEED_TIME_TO_LOVE_HOMEOWNERS_LANDING_PAGE_EXPERIMENT,
  useIsClientReady,
} from '@belong/common';
import clsx from 'clsx';
import { GttlLandingPage } from 'src/features/homeowners/components/gttl-landing-page/gttl-landing-page';
import {
  LandingPage,
  type ServerProps,
} from 'src/features/homeowners/components/landing-page/landing-page';
import { useExperimentVariant } from 'src/hooks/use-experiment-variant';

/**
 * This component is used to switch between the old and new landing pages based on the experiment variant.
 * Not entirely sure why we need this but moving the switching logic to the page level causes a more/less expected hooks
 * than expected in the rendered output.
 * It appeared to be related to the useIsClientReady hook.
 *
 * Also, once we can be sure that this is the only way, perhaps we could create a wrapper that works whenever we need to
 * switch between different page variants until we can implement something like path rewriting right in the middleware.
 */
export function LandingPageSwitcher({
  blogPosts,
  homeownersCount,
  coverageCities,
  heroCopyVariant,
}: ServerProps) {
  const isClientReady = useIsClientReady();

  const gttlLandingPageExperimentVariant = useExperimentVariant(
    NEW_GUARANTEED_TIME_TO_LOVE_HOMEOWNERS_LANDING_PAGE_EXPERIMENT.name,
  );

  return (
    <div
      className={clsx(
        isClientReady ? 'opacity-100' : 'opacity-0',
        'duration-hover transition-all',
      )}
    >
      {gttlLandingPageExperimentVariant === 'test' ? (
        <GttlLandingPage
          blogPosts={blogPosts}
          coverageCities={coverageCities}
          heroCopyVariant={heroCopyVariant}
        />
      ) : (
        <LandingPage
          blogPosts={blogPosts}
          homeownersCount={homeownersCount}
          coverageCities={coverageCities}
        />
      )}
    </div>
  );
}
